import {hasRichText, type Props as RichTextProps} from '@/components/rich-text'

/**
 * A page document (of any Prismic type) that carries the shared `notification_banner`
 * content relation. The banner's rich text lives on the linked PrismicNotificationBanner
 * document's `banner_content` field.
 */
type BannerBearingDoc = {
    data?: {
        notification_banner?: {
            document?: {data?: {banner_content?: {richText?: RichTextProps['content']}}} | null
        } | null
    }
}

/**
 * Extracts notification-banner rich text from a Gatsby page's `data`, independent of
 * which doc type the page is. Every page query returns one Prismic document under a
 * type-specific root key (`prismicHomepageV4`, `prismicSlicePage`, …), so we scan the
 * values rather than naming the key. Any doc type whose query selects
 * `notification_banner { ...NotificationBannerLink }` is picked up with no extra wiring.
 *
 * Returns the first non-empty rich text found, or `null` when no banner is set.
 */
export const getNotificationBannerContent = (data: object): RichTextProps['content'] => {
    for (const node of Object.values(data ?? {})) {
        const richText = (node as BannerBearingDoc)?.data?.notification_banner?.document?.data
            ?.banner_content?.richText

        if (hasRichText(richText)) {
            return richText
        }
    }

    return null
}
